import { Component, OnInit, Input } from '@angular/core';
import { ConfirmationSelfiePictureService } from './confirmation-selfie-picture.service';
export class ConfirmationSelfiePictureComponent implements OnInit {
public profile: any;
public loan: any;
public data: any;
/**
 * @param {?} service
 */
constructor(public service: ConfirmationSelfiePictureService) {
    this.service.dataStore.subscribe(res => {
      this.data = res;
    });
  }
/**
 * @return {?}
 */
ngOnInit(): void {
    this.service.setStore({
      profile: this.profile,
      loan: this.loan,
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'confirmation-selfie-picture',
  template: `
    <div class="tnk-card">
      <div class="tnk-card__header">
        <h1>Foto Selfie</h1>
        <div>
          <small>Langkah 4 dari 4</small>
        </div>
      </div>
      <div class="tnk-card__body">
        <div class="tnk-padding">
          <div class="main-content">
            <div>
              <form>
                <div class="row">
                  <div class="col-xs-12">
                    <ul class="tnk-ul">
                      Mohon unggah foto yang jelas:
                      <li class="tnk-li">
                        Wajah terlihat jelas dan tidak terpotong
                      </li>
                      <li class="tnk-li">Memegang kartu identitas (KTP)</li>
                      <li class="tnk-li">
                        Posisi foto vertikal (tidak menyamping)
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xs-12">
                    <div class="exampling-container">
                      <div class="exampling-container__item">
                        <div class="row">
                          <div class="col-xs-12">
                            <h2>Contoh Foto Selfie</h2>
                          </div>
                        </div>
                        <div class="exampling-container__item-row">
                          <div class="exampling-img text-green img-padding">
                            <img
                              class="img-responsive"
                              src="assets/images/contoh_selfie_benar.png"
                              alt="Selfie Benar"
                            />
                            <h4>Benar</h4>
                          </div>
                          <div class="exampling-img text-red img-padding">
                            <img
                              class="img-responsive"
                              src="assets/images/contoh_selfie_salah.png"
                              alt="Selfie Salah"
                            />
                            <h4>Salah</h4>
                          </div>
                          <div class="exampling-img text-red img-padding">
                            <img
                              class="img-responsive"
                              src="assets/images/contoh_selfie_horizontal.png"
                              alt="Selfie Salah"
                            />
                            <h4>Salah</h4>
                          </div>
                        </div>
                        <div class="text-center">
                          <small>
                            Pastikan foto yang diambil sesuai karena akan
                            diverifikasi oleh tim Tunaiku
                          </small>
                        </div>
                      </div>

                      <div
                        class="exampling-container__preview"
                        *ngIf="data.isValid || data.isError"
                      >
                        <img [src]="data.preview" />
                        <div>
                          <small>{{ data.image?.name }}</small>
                        </div>
                      </div>

                      <div>
                        <div class="progress" *ngIf="data.isValid || data.isError">
                          <div
                            class="progress-bar progress-bar-striped progress-bar-success"
                            [style.width]="data.progress + '%'"
                          >
                            {{ data.progress + '%' }}
                          </div>
                        </div>
                      </div>

                      <div
                        class="exampling-container__error"
                        *ngIf="data.isError == 'file'"
                      >
                        <p>
                          <span><i class="fa fa-exclamation-circle"></i></span>
                          Maaf, terjadi error. Pastikan ukuran foto tidak lebih dari
                          2mb dan Pastikan format foto sesuai. Jika sudah sesuai
                          tapi masih gagal, mohon tunggu sesaat sebelum mengunggah
                          lagi
                        </p>
                      </div>
                      <div
                        class="exampling-container__error"
                        *ngIf="data.isError == 'connection'"
                      >
                        <p>
                          <span><i class="fa fa-exclamation-circle"></i></span>
                          Mohon maaf terjadi masalah koneksi. Silakan unggah lagi
                          saat sinyal internet Anda lebih baik
                        </p>
                      </div>
                      <div
                        class="exampling-container__error"
                        *ngIf="data.isError == 'server'"
                      >
                        <p>
                          <span><i class="fa fa-exclamation-circle"></i></span>
                          Mohon maaf terjadi masalah server. Silakan unggah foto
                          beberapa jam lagi.
                        </p>
                      </div>

                      <button
                        [ngClass]="{ disabled: data.isBusy }"
                        class="tnk-button__blue block"
                        (click)="service.compressFile()"
                      >
                        {{ data.isBusy ? 'Uploading' : 'Unggah dari galeri' }}
                      </button>
                      <div>
                        <small>
                          Format file: JPG, PNG (maksimum 2mb)
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="tnk-card__nav">
      <div class="tnk-padding">
        <div class="row">
          <div class="col-xs-6">
            <button
              class="tnk-button__green block"
              (click)="service.parentService.prevStep()"
            >
              Sebelumnya
            </button>
          </div>
          <div class="col-xs-6">
            <button
              (click)="service.parentService.sendForm()"
              [disabled]="data.progress !== 100"
              [ngClass]="{ disabled: data.progress !== 100 }"
              class="tnk-button__green block active right"
            >
              Kirim Formulir
            </button>
          </div>
        </div>
      </div>
    </div>

    <tnk-modal [isOpen]="data.modal == 'success'">
      <tnk-modal-body class="tnk-align--center">
        <h5 class="tnk-color--secondary">
          Formulir Konfirmasi Anda sudah terkirim!
        </h5>
        <p>
          Terima kasih telah mengirimkan formulir konfirmasi. Status pinjaman Anda
          akan diperbaharui setelah Anda menerima notifikasi SMS dan email draft
          kontrak.
        </p>
      </tnk-modal-body>
      <tnk-modal-footer>
        <button
          class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
          (click)="service.closeSuccessModal()"
        >
          Saya Mengerti
        </button>
      </tnk-modal-footer>
    </tnk-modal>

    <tnk-modal [isOpen]="data.modal == 'failed'">
      <tnk-modal-body class="tnk-align--center">
        <h5 class="tnk-color--secondary">Maaf terjadi kesalahan</h5>
        <p>Terjadi kesalahan. Silahkan cek kembali form Anda.</p>
      </tnk-modal-body>
      <tnk-modal-footer>
        <button
          class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
          (click)="service.closeModal()"
        >
          Saya Mengerti
        </button>
      </tnk-modal-footer>
    </tnk-modal>

    <tnk-modal [isOpen]="data.modal == 'error'">
      <tnk-modal-body class="tnk-align--center">
        <h5 class="tnk-color--secondary">
          Mohon maaf terdapat kesalahan dengan sistem kami
        </h5>
        <p>Mohon maaf terjadi masalah server. Silakan coba beberapa saat lagi.</p>
      </tnk-modal-body>
      <tnk-modal-footer>
        <button
          class="tnk-button tnk-button--secondary tnk-button--full-width tnk-button--pill"
          (click)="service.closeModal()"
        >
          Saya Mengerti
        </button>
      </tnk-modal-footer>
    </tnk-modal>
  `,
  styles: [`
    .tnk-card {
      background: #fdfdfd;
      border-left: 5px solid #ffc412;
      border-radius: 5px;
      color: #535353;
      margin-bottom: 15px; }
      .tnk-card__nav {
        margin: 15px 0; }
      .tnk-card__header {
        border-bottom: 1px solid #e1e1e1;
        padding: 15px;
        -ms-flex-flow: wrap;
            flex-flow: wrap; }
        .tnk-card__header h1 {
          font-size: 16px;
          margin: 0;
          width: 100%; }
        .tnk-card__header small {
          font-size: 12px;
          color: #9b9b9b;
          width: 100%; }
      .tnk-card__body {
        padding: 10px 0; }
        .tnk-card__body .exampling-container__item {
          background: #f4f4f4;
          border-radius: 10px;
          padding: 10px;
          margin: 5px 0 15px 0;
          text-align: center; }
          .tnk-card__body .exampling-container__item-row {
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-orient: horizontal;
            -webkit-box-direction: normal;
                -ms-flex-direction: row;
                    flex-direction: row;
            justify-items: center;
            -webkit-box-pack: center;
                -ms-flex-pack: center;
                    justify-content: center;
            margin: 0 auto; }
          .tnk-card__body .exampling-container__item .img-padding {
            padding: 4px; }
          .tnk-card__body .exampling-container__item .exampling-img {
            margin: 5px 0 10px 0; }
            .tnk-card__body .exampling-container__item .exampling-img.text-red {
              color: #ff0000; }
            .tnk-card__body .exampling-container__item .exampling-img.text-green {
              color: #80bd01; }
            .tnk-card__body .exampling-container__item .exampling-img img {
              margin: 0 auto;
              height: 100px; }
            .tnk-card__body .exampling-container__item .exampling-img h4 {
              margin: 5px 0;
              font-size: 12px;
              font-weight: bolder; }
          .tnk-card__body .exampling-container__item h2 {
            font-size: 14px;
            margin: 0 0 10px 0;
            text-align: center;
            font-weight: bolder; }
          .tnk-card__body .exampling-container__item small {
            font-size: 12px;
            margin: 5px 0; }
        .tnk-card__body .exampling-container__preview img {
          max-width: 150px; }
        .tnk-card__body .exampling-container__error p {
          color: #ff0000;
          padding-bottom: 10px; }
        .tnk-card__body .cancel-content form div {
          margin: 15px 0; }
        .tnk-card__body .form-group p {
          font-size: 12px;
          margin: -7px 0 4px 0; }
        .tnk-card__body h1 {
          margin: 0;
          font-size: 16px;
          font-weight: bolder;
          line-height: 21px; }
        .tnk-card__body h4 {
          margin: 0;
          font-size: 12px; }
        .tnk-card__body ul {
          padding: 0;
          margin: 0; }
          .tnk-card__body ul li:not(.tnk-li) {
            list-style-type: none; }
        .tnk-card__body ul.tnk-ul {
          margin-left: 15px; }
        .tnk-card__body strong {
          font-weight: bolder; }
        .tnk-card__body p {
          font-size: 14px;
          line-height: 21px; }
        .tnk-card__body p.tnk-confirmation--p {
          font-size: 16px; }
        .tnk-card__body small {
          font-size: 12px; }

    .p-t {
      padding-top: 10px; }

    .p-b {
      padding-bottom: 10px; }

    .p-y {
      padding: 5px 0px; }

    .p-x {
      padding: 0px 5px; }

    .tnk-button__blue {
      width: 120px;
      color: #0087c6;
      background-color: #fdfdfd;
      border: 2.5px solid #0087c6;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__blue.active {
        color: #fdfdfd;
        background-color: #0087c6; }
      .tnk-button__blue.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__blue.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }

    .tnk-button__green {
      width: 120px;
      color: #80bd01;
      background-color: #fdfdfd;
      border: 2.5px solid #80bd01;
      border-radius: 5px;
      line-height: 13px;
      padding: 5px;
      margin: 5px 0; }
      .tnk-button__green.active {
        color: #fdfdfd;
        background-color: #80bd01; }
      .tnk-button__green.disabled {
        color: #e1e1e1;
        cursor: not-allowed;
        background-color: #9b9b9b;
        border-color: #9b9b9b; }
      .tnk-button__green.block {
        width: 100%;
        max-width: 180px;
        text-transform: capitalize;
        padding: 13px 0 10px 0;
        text-align: center; }
      .tnk-button__green.right {
        float: right; }

    .info-card {
      width: 100%;
      background-color: #fffcdb; }

    .info-card--mobile-view {
      display: none; }

    .info-card--desktop-view {
      display: inline; }

    @media (max-width: 768px) {
      .info-card--mobile-view {
        display: inline; }
      .info-card--desktop-view {
        display: none; } }
  `],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ConfirmationSelfiePictureService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'profile': [{ type: Input, args: ['profile', ] },],
'loan': [{ type: Input, args: ['loan', ] },],
};
}

function ConfirmationSelfiePictureComponent_tsickle_Closure_declarations() {
/** @type {?} */
ConfirmationSelfiePictureComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
ConfirmationSelfiePictureComponent.ctorParameters;
/** @type {?} */
ConfirmationSelfiePictureComponent.propDecorators;
/** @type {?} */
ConfirmationSelfiePictureComponent.prototype.profile;
/** @type {?} */
ConfirmationSelfiePictureComponent.prototype.loan;
/** @type {?} */
ConfirmationSelfiePictureComponent.prototype.data;
/** @type {?} */
ConfirmationSelfiePictureComponent.prototype.service;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
